<template>
  <div>
    <download-excel
      style="width: 100px"
      :data="data"
      :fields="json_fields"
      type="xls"
      name="订单收入图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-modal v-model="visible" @ok="changOk" :width="820" title="财务详情">
      <div>
        <a-form-model>
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="订单编号">
                <a-input v-model="details[0].orderNo" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item label="收支类型">
                <a-input
                  placeholder=""
                  v-model="details[0].moneyAddStr"
                ></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="订单类型">
                <a-input v-model="details[0].financeTypeStr" placeholder="">
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item label="交易状态">
                <a-input v-model="details[0].financeStatusStr" placeholder="">
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="用户uid">
                <a-input v-model="details[0].userId" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item label="落地金额">
                <a-input v-model="details[0].orderNo" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="订单金额">
                <a-input v-model="details[0].orderNo" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item label="佣金率">
                <a-input v-model="details[0].rateStr" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="佣金金额">
                <a-input v-model="details[0].moneyRate" placeholder="">
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item label="财务时间">
                <a-input v-model="details[0].time" placeholder=""> </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel">
          返回
        </a-button>
      </template>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 1300 }"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click.prevent="getOrderIncomeListDetails(operate)">财务详情</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import { orderIncomeList, orderIncomeListDetails } from "@/api/orderApi.js";
import { orderSeach } from "@/api/homeApi.js";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
  },
  {
    title: "订单编号",
    dataIndex: "orderNo",
  },
  {
    title: "用户uid",
    dataIndex: "userId",
  },
  {
    title: "订单类型",
    dataIndex: "financeTypeStr",
    sorter: true,
  },
  {
    title: "金额",
    dataIndex: "moneyClean",
    sorter: true,
    scopedSlots: { customRender: "moneyClean" },
  },
  {
    title: "佣金金额(元)",
    dataIndex: "moneyRate",
    sorter: true,
  },
  {
    title: "交易状态",
    dataIndex: "financeStatusStr",
    sorter: true,
  },
  {
    title: "时间",
    dataIndex: "time",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    width: 100,
    scopedSlots: { customRender: "operate" },
    fixed: "right",
  },
];

export default {
  data() {
    return {
      data: [],
      details: [
        {
          orderNo: "",
          financeStatusStr: "",
          financeTypeStr: "",
          orderTypeStr: "",
          rateStr: "",
          moneyRate: "",
          time: "",
          moneyAddStr: "",
          userId: "",
        },
      ],
      json_fields: {
        编号: "objId",
        订单编号: "orderNo",
        用户uid: "userId",
        订单类型: "financeType",
        金额: "moneySubmit",
        佣金金额: "moneyRate",
        交易状态: "financeStatusStr",
        时间: "time",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getorderIncomeListData();
    this.formInline;
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      orderIncomeList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    // 订单收入列表数据
    getorderIncomeListData() {
      orderIncomeList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    // 财务详情数据
    getOrderIncomeListDetails(row) {
      this.visible = true;
      orderIncomeListDetails(10, 1, row.orderNo).then((res) => {
        this.details = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    query() {
      this.loading = true;
      orderSeach(
        10,
        1,
        this.formInline.orderNo,
        this.formInline.name,
        this.formInline.phone,
        this.formInline.endTime,
        this.formInline.beginTime
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    handleCancel() {
      this.visible = false;
    },
    getdata() {
      getOrdeRrevenue(1, 10).then((res) => {
        this.data = res;
      });
    },
    changOk() {
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/financialManagement/orderRevenue/orderRevenueContent.vue